const getAllOperatorsResponse = (response) => {
  return response?.data?.users.map((operator) => {
    return {
      value: operator?.id,
      label: `${operator?.name}`,
    };
  });
};

export default getAllOperatorsResponse;
